import { render, staticRenderFns } from "./StockInvoiceHero.vue?vue&type=template&id=3babca9a&scoped=true"
import script from "./StockInvoiceHero.vue?vue&type=script&lang=js"
export * from "./StockInvoiceHero.vue?vue&type=script&lang=js"
import style0 from "./StockInvoiceHero.vue?vue&type=style&index=0&id=3babca9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3babca9a",
  null
  
)

export default component.exports